export default __webpack_public_path__ + "static/media/driveways-banner.14cc00a7.jpg";